// disable-if-product-in-cart.js
// Production: robust UI + network guards for "already in cart" + SKIP_TO_CHECKOUT mode.
// Captures add clicks and cart/add form submits globally and, if SKIP_TO_CHECKOUT=true,
// performs an AJAX add then redirects to /checkout (unless the product is already in cart).
(function () {
  'use strict';

  var POLL_INTERVAL = 5000;
  var MUTATION_DEBOUNCE = 120;
  var CART_TTL = 1000;
  var SKIP_TO_CHECKOUT = true; // set true to AJAX-add then goto /checkout

  function toInt(v) { return v ? parseInt(v, 10) : NaN; }

  function findProductInfo() {
    return document.querySelector('product-info[data-product-id]') || document.querySelector('[id^="MainProduct-"][data-product-id]');
  }
  function getProductId(el) { return el ? toInt(el.getAttribute('data-product-id')) : NaN; }

  function gatherVariantIds(productInfoEl) {
    var ids = new Set();
    if (!productInfoEl) return ids;
    Array.from(productInfoEl.querySelectorAll('select[name="id"], select[name="variant"], select[name="variant_id"]')).forEach(function (s) {
      Array.from(s.options).forEach(function (opt) { var v = toInt(opt.value); if (!isNaN(v)) ids.add(v); });
    });
    Array.from(productInfoEl.querySelectorAll('input[name="id"], input[name="variant_id"], input[name="variant"]')).forEach(function (inp) {
      var v = toInt(inp.value); if (!isNaN(v)) ids.add(v);
    });
    Array.from(productInfoEl.querySelectorAll('[data-variant-id], [data-variant], [data-product-variant]')).forEach(function (d) {
      var v = toInt(d.getAttribute('data-variant-id') || d.getAttribute('data-variant') || d.getAttribute('data-product-variant'));
      if (!isNaN(v)) ids.add(v);
    });
    return ids;
  }

  var cartCache = { ts: 0, data: null, ttl: CART_TTL };
  function fetchCartCached() {
    var now = Date.now();
    if (cartCache.data && (now - cartCache.ts) < cartCache.ttl) return Promise.resolve(cartCache.data);
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartCache.ts = Date.now(); cartCache.data = cart; return cart; })
      .catch(function () { return { items: [] }; });
  }
  function isProductInCart(productId) {
    if (!productId) return Promise.resolve(false);
    return fetchCartCached().then(function (cart) {
      return (cart.items || []).some(function (item) { return toInt(item.product_id) === productId && toInt(item.quantity) >= 1; });
    }).catch(function () { return false; });
  }
  function isProductInCartSync(productId) {
    if (!productId || !cartCache.data) return false;
    return (cartCache.data.items || []).some(function (item) { return toInt(item.product_id) === productId && toInt(item.quantity) >= 1; });
  }

  function findFormAndButton(productInfoEl) {
    if (!productInfoEl) return { form: null, button: null };
    var form = productInfoEl.querySelector('form[action^="/cart/add"], form.product-form') || productInfoEl.querySelector('form');
    var button = null;
    if (form) button = form.querySelector('button[type="submit"], input[type="submit"], input[type="button"], .product-form__cart-submit, [name="add"], [data-add-to-cart], [data-action="add-to-cart"], [aria-label*="Add to cart"]');
    if (!button) {
      var candidates = productInfoEl.querySelectorAll('button, a, input[type="submit"], input[type="button"]');
      button = Array.from(candidates).find(function (el) {
        var txt = (el.innerText || el.value || el.getAttribute('aria-label') || '').trim();
        if (/add to cart/i.test(txt)) return true;
        if (el.getAttribute && (el.getAttribute('name') === 'add')) return true;
        if (el.matches && (el.matches('[data-add-to-cart]') || el.matches('[data-action="add-to-cart"]') || el.matches('[data-add-to-cart-button]'))) return true;
        return false;
      }) || null;
    }
    if (!button && form) button = form.querySelector('button, input[type="submit"], input[type="button"]') || null;
    return { form: form, button: button };
  }

  function disableUI(productInfoEl, message) {
    var els = findFormAndButton(productInfoEl);
    var btn = els.button;
    var form = els.form || productInfoEl;
    if (btn) {
      if (!btn.dataset._origText) btn.dataset._origText = (btn.innerText || btn.value || '').trim();
      if ('disabled' in btn) {
        btn.disabled = true; btn.setAttribute('aria-disabled', 'true');
        if (btn.tagName.toLowerCase() === 'input') { try { btn.value = message || 'Limit Reached'; } catch (e) {} }
        else btn.innerText = message || 'Limit Reached';
      } else {
        btn.setAttribute('aria-disabled', 'true'); btn.style.pointerEvents = 'none'; btn.style.opacity = btn.style.opacity || '0.7';
        try { if (btn.tagName.toLowerCase() === 'a') { if (!btn.dataset._origText) btn.dataset._origText = (btn.innerText || '').trim(); btn.innerText = message || 'Limit Reached'; } } catch (e) {}
      }
    }
    Array.from(productInfoEl.querySelectorAll('.product-form__quantity-selector, .quantity-selector, .quantity')).forEach(function (w) { w.style.display = 'none'; });
    if (!productInfoEl.querySelector('.product-limit-notice')) {
      var p = document.createElement('p'); p.className = 'product-limit-notice';
      p.textContent = 'This item is limited to one per customer and is already in your cart.';
      p.style.color = '#b00'; p.style.marginTop = '.5em';
      if (form && form.parentNode) form.parentNode.insertBefore(p, form.nextSibling); else productInfoEl.appendChild(p);
    }
  }

  function enableUI(productInfoEl) {
    var els = findFormAndButton(productInfoEl);
    var btn = els.button;
    var form = els.form || productInfoEl;
    if (btn) {
      if ('disabled' in btn) {
        btn.disabled = false; btn.removeAttribute('aria-disabled');
        if (btn.dataset && btn.dataset._origText) {
          if (btn.tagName.toLowerCase() === 'input') try { btn.value = btn.dataset._origText; } catch (e) {}
          else btn.innerText = btn.dataset._origText;
        }
        btn.style.opacity = ''; btn.style.cursor = '';
      } else {
        btn.removeAttribute('aria-disabled'); btn.style.pointerEvents = ''; btn.style.opacity = '';
        if (btn.dataset && btn.dataset._origText) try { btn.innerText = btn.dataset._origText; } catch (e) {}
      }
    }
    Array.from(productInfoEl.querySelectorAll('.product-form__quantity-selector, .quantity-selector, .quantity')).forEach(function (w) { w.style.display = ''; });
    var note = productInfoEl.querySelector('.product-limit-notice'); if (note) note.remove();
  }

  function extractVariantIdFromBody(body) {
    try {
      if (!body) return NaN;
      if (typeof FormData !== 'undefined' && body instanceof FormData) { var v = body.get('id') || body.get('variant') || body.get('variant_id'); return toInt(v); }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) { var v2 = body.get('id') || body.get('variant') || body.get('variant_id'); return toInt(v2); }
      if (typeof body === 'string') {
        var t = body.trim();
        if (t[0] === '{') try { var j = JSON.parse(t); return toInt(j.id || j.variant_id || j.variant); } catch (e) {}
        try { var usp = new URLSearchParams(t); var vv = usp.get('id') || usp.get('variant') || usp.get('variant_id'); return toInt(vv); } catch (e) {}
      }
      if (typeof body === 'object') return toInt(body.id || body.variant || body.variant_id);
    } catch (e) {}
    return NaN;
  }

  function blockedResponse() {
    var payload = JSON.stringify({ status: 'error', message: 'This item is limited to one per customer.' });
    return Promise.resolve(new Response(payload, { status: 400, headers: { 'Content-Type': 'application/json' } }));
  }

  function ajaxAddVariant(variantId, quantity) {
    quantity = (typeof quantity === 'undefined' || quantity === null) ? 1 : quantity;
    var body = 'id=' + encodeURIComponent(String(variantId)) + '&quantity=' + encodeURIComponent(String(quantity));
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body
    }).then(function (res) {
      return res.json().catch(function () { return { error: 'invalid-json' }; });
    });
  }

  // intercept fetch/XHR for ajax adds (blocks duplicate AJAX adds for product in cart)
  function interceptFetch(productInfoEl, variantSet, productId) {
    if (!window.fetch) return;
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var method = (init && init.method) || (typeof input === 'object' && input && input.method) || 'GET';
        var body = init && init.body;
        if (typeof url === 'string' && /\/cart\/add(\.js|\.json)?/i.test(url) && (/post/i).test(method)) {
          var vid = extractVariantIdFromBody(body);
          if (!isNaN(vid) && variantSet.has(vid)) {
            return isProductInCart(productId).then(function (inCart) {
              if (inCart) { disableUI(productInfoEl, 'Limit Reached'); return blockedResponse(); }
              return origFetch(input, init);
            });
          }
        }
      } catch (e) {}
      return origFetch(input, init);
    };
  }

  function interceptXHR(productInfoEl, variantSet, productId) {
    if (!window.XMLHttpRequest) return;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__isInterceptedForAdd = false;
      try { if (typeof url === 'string' && /\/cart\/add(\.js|\.json)?/i.test(url) && (/post/i).test(method)) this.__isInterceptedForAdd = true; } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (this.__isInterceptedForAdd) {
          var vid = extractVariantIdFromBody(body);
          if (!isNaN(vid) && variantSet.has(vid)) {
            var xhr = this;
            isProductInCart(productId).then(function (inCart) {
              if (inCart) { try { xhr.abort(); } catch (e) {} disableUI(productInfoEl, 'Limit Reached'); try { xhr.dispatchEvent(new Event('error')); } catch (e) {} return; }
              else origSend.apply(xhr, arguments);
            });
            return;
          }
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  }

  // resolve variant + qty from a node (closest form or data attributes)
  function resolveVariantAndQtyFromNode(node) {
    var vid = NaN, qty = 1;
    if (!node) return { vid: NaN, qty: 1 };
    var form = node.tagName && node.tagName.toLowerCase() === 'form' ? node : (node.closest ? node.closest('form') : null);
    if (form) {
      var idEl = form.querySelector('input[name="id"], select[name="id"], input[name="variant"], input[name="variant_id"]');
      if (idEl) {
        if (idEl.tagName && idEl.tagName.toLowerCase() === 'select') vid = toInt(idEl.options[idEl.selectedIndex] && idEl.options[idEl.selectedIndex].value);
        else vid = toInt(idEl.value);
      }
      var qtyEl = form.querySelector('input[name="quantity"], input[name="qty"], input[name="cart_quantity"], input[type="number"]');
      if (qtyEl && qtyEl.value) qty = Math.max(1, toInt(qtyEl.value) || 1);
    }
    // fallback to data attributes
    if (isNaN(vid) && node.getAttribute) {
      var d = node.getAttribute('data-variant-id') || node.getAttribute('data-variant') || node.getAttribute('data-product-variant') || node.getAttribute('data-variant-id');
      if (d) vid = toInt(d);
    }
    return { vid: vid, qty: qty };
  }

  // determine if element is an "add to cart" control
  function isAddControl(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches && (el.matches('[data-add-to-cart]') || el.matches('[data-action="add-to-cart"]') || el.matches('[data-add-to-cart-button]'))) return true;
    var tag = el.tagName && el.tagName.toLowerCase();
    if (tag === 'button' || tag === 'input' || tag === 'a') {
      var txt = (el.innerText || el.value || el.getAttribute('aria-label') || '').trim();
      if (/add to cart|add to bag|add to basket/i.test(txt)) return true;
    }
    if (tag === 'a') {
      var href = el.getAttribute('href') || '';
      if (/\/cart|\/checkout/i.test(href)) return true;
    }
    return false;
  }

  // global handlers to ensure any add action goes through AJAX+checkout when SKIP_TO_CHECKOUT=true
  function installGlobalAddInterception(productInfoEl, variantSet, productId) {
    // capture clicks on add controls anywhere on page
    document.addEventListener('click', function (evt) {
      try {
        var el = evt.target;
        if (!el) return;
        var candidate = el.closest && el.closest('[data-add-to-cart], [data-action="add-to-cart"], [data-add-to-cart-button], form, button, a, input') || el;
        if (!candidate) return;
        if (!isAddControl(candidate)) {
          // search ancestors up to document for add controls
          var anc = candidate;
          var found = null;
          while (anc && anc !== document && anc !== document.documentElement) {
            if (isAddControl(anc)) { found = anc; break; }
            anc = anc.parentElement;
          }
          if (found) candidate = found;
          else return;
        }
        var ref = resolveVariantAndQtyFromNode(candidate);
        var vid = ref.vid, qty = ref.qty;
        if (isNaN(vid)) return; // couldn't resolve variant
        // If this vid is not part of our product's variant set, do nothing
        if (!variantSet.has(vid)) return;
        // intercept
        evt.preventDefault();
        try { evt.stopImmediatePropagation(); } catch (e) {}
        isProductInCart(productId).then(function (inCart) {
          if (inCart) { disableUI(productInfoEl, 'Limit Reached'); return; }
          if (SKIP_TO_CHECKOUT) {
            ajaxAddVariant(vid, qty).then(function () {
              // redirect to checkout
              try { window.location.href = '/checkout'; } catch (e) { /* fallback to form submit if any */ }
            }).catch(function () {
              // fallback to native submit if AJAX fails
              var form = candidate.closest && candidate.closest('form');
              try { form && form.submit && form.submit(); } catch (e) {}
            });
          } else {
            var form = candidate.closest && candidate.closest('form');
            try { form && form.submit && form.submit(); } catch (e) {}
          }
        });
      } catch (e) {}
    }, true);

    // intercept form submissions to /cart/add (covers direct submits)
    document.addEventListener('submit', function (evt) {
      try {
        var form = evt.target;
        if (!form || form.tagName.toLowerCase() !== 'form') return;
        var action = form.getAttribute('action') || '';
        if (!/\/cart\/add(\.js|\/?$)/i.test(action) && !form.querySelector('input[name="id"], select[name="id"]')) return;
        // resolve variant+qty
        var ref = resolveVariantAndQtyFromNode(form);
        var vid = ref.vid, qty = ref.qty;
        if (isNaN(vid)) return;
        if (!variantSet.has(vid)) return;
        // intercept
        evt.preventDefault();
        try { evt.stopImmediatePropagation(); } catch (e) {}
        isProductInCart(productId).then(function (inCart) {
          if (inCart) { disableUI(productInfoEl, 'Limit Reached'); return; }
          if (SKIP_TO_CHECKOUT) {
            ajaxAddVariant(vid, qty).then(function () {
              try { window.location.href = '/checkout'; } catch (e) { try { form.submit(); } catch (err) {} }
            }).catch(function () {
              try { form.submit(); } catch (e) {}
            });
          } else {
            try { form.submit(); } catch (e) {}
          }
        });
      } catch (e) {}
    }, true);
  }

  function attachMutationObserver(productInfoEl, variantSet, productId) {
    try {
      var timeout = null;
      var obs = new MutationObserver(function () {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(function () {
          var newSet = gatherVariantIds(productInfoEl);
          variantSet.clear(); newSet.forEach(function (x) { variantSet.add(x); });
          // no per-form reattach needed because global handler inspects variantSet each time
        }, MUTATION_DEBOUNCE);
      });
      obs.observe(productInfoEl, { childList: true, subtree: true, attributes: true });
      productInfoEl.__disable_if_cart_obs = obs;
    } catch (e) {}
  }

  function init() {
    var productInfoEl = findProductInfo(); if (!productInfoEl) return;
    var productId = getProductId(productInfoEl); if (!productId) return;
    var variantSet = gatherVariantIds(productInfoEl);
    fetchCartCached();
    isProductInCart(productId).then(function (inCart) { if (inCart) disableUI(productInfoEl, 'Limit Reached'); else enableUI(productInfoEl); });
    attachMutationObserver(productInfoEl, variantSet, productId);
    interceptFetch(productInfoEl, variantSet, productId);
    interceptXHR(productInfoEl, variantSet, productId);
    installGlobalAddInterception(productInfoEl, variantSet, productId);
    var poll = setInterval(function () {
      fetchCartCached().then(function () { isProductInCart(productId).then(function (inCart) { if (inCart) disableUI(productInfoEl, 'Limit Reached'); else enableUI(productInfoEl); }); });
    }, POLL_INTERVAL);
    window.addEventListener('beforeunload', function () { clearInterval(poll); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();